import axios from 'axios';
import * as actionTypes from './actionTypes';

export const searchMacLoading = () => {
    return {
        type: actionTypes.SEARCH_MAC_LOADING
    }
};

export const searchMacFail = (error) => {
    return {
        type: actionTypes.SEARCH_MAC_FAIL,
        error: error
    }
};

export const searchMacSuccess = (data) => {
    return {
        type: actionTypes.SEARCH_MAC_SUCCESS,
        payload: data
    }
};

export const searchMacInitialize = () => {
    return {
        type: actionTypes.SEARCH_MAC_INITIALIZE
    }
};

export const initializeSearchMac = () => {
    return dispatch => {
        dispatch(searchMacInitialize())
    }
};

export const searchMac = (token, mac) => {
    return dispatch => {
        dispatch(searchMacLoading());
        axios.get('/api/searchmac/' + mac + '?token=' + token )
            .then(res => {
                console.log(res);
                dispatch(searchMacSuccess(res.data));
            }).catch(error => {
                //console.log('error data', error);
                let message = "Server error, try again later";
                if (error.response){
                    message = error.response.data.message;
                }
                console.log('logging message', message);
                dispatch(searchMacFail(message));
        });
    }
};

export const searchMacReseller = (token, mac) => {
    return dispatch => {
        dispatch(searchMacLoading());
        axios.get('/reseller/searchmac/' + mac + '?token=' + token )
            .then(res => {
                console.log(res);
                dispatch(searchMacSuccess(res.data));
            }).catch(error => {
                //console.log('error data', error);
                let message = "Server error, try again later";
                if (error.response){
                    message = error.response.data.message;
                }
                console.log('logging message', message);
                dispatch(searchMacFail(message));
        });
    }
};

export const searchMacSuperReseller = (token, mac) => {
    return dispatch => {
        dispatch(searchMacLoading());
        axios.get('/superreseller/searchmac/' + mac + '?token=' + token )
            .then(res => {
                console.log(res);
                dispatch(searchMacSuccess(res.data));
            }).catch(error => {
                //console.log('error data', error);
                let message = "Server error, try again later";
                if (error.response){
                    message = error.response.data.message;
                }
                console.log('logging message', message);
                dispatch(searchMacFail(message));
        });
    }
};

